import { Add, Close, CloseFullscreen, Delete, Fullscreen } from '@mui/icons-material';
import { Alert, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, IconButton, List, ListItem, ListItemText, Slide, Snackbar, Stack, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { CategoryTemplateDTO, CategoryTemplateItemDTO } from '../../../../ApiOld/Api/ApiServerVov';
import { Validate } from 'mui-validate';
import DeleteDialog from '../../../Shared/Layouts/DeleteDialog';

interface CategoryTemplateDetailDialogProps {
    open: boolean;
    onClose: (template: CategoryTemplateDTO | undefined) => void;
    template: CategoryTemplateDTO;
}
export default function CategoryTemplateDetailDialog(props: CategoryTemplateDetailDialogProps) {
    const { open, onClose, template } = props;

    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
    const [deleteItem, setDeleteItem] = useState<CategoryTemplateItemDTO>();
    const [templateLocal, setTemplateLocal] = useState<CategoryTemplateDTO>();
    const [fullScreenLocal, setFullScreenLocal] = useState(false);


    var theme = useTheme();

    useEffect(() => {
        setTemplateLocal(template);
    }, [template]);

    const handleChange = (itm, newName) => {
        setTemplateLocal(new CategoryTemplateDTO({ ...templateLocal, templateItems: templateLocal?.templateItems?.map((item) => (item === itm ? new CategoryTemplateItemDTO({ ...item, name: newName }) : item)) ?? [] }));
    };

    const handleDelete = (itm) => {
        setDeleteItem(templateLocal?.templateItems?.find(p => p === itm));
    };

    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            fullScreen={fullScreenLocal}
            onClose={() => { onClose(undefined) }}
            aria-labelledby="category-dialog-title"
            aria-describedby="category-dialog-description"
        >
            <DialogTitle id="category-dialog-title" >
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant='h5'>{template.id! < 0 ? t('newTemplate') : t('editTemplate')}</Typography>

                    <div style={{ float: 'right', display: 'flex', alignContent: 'flex-end' }}>
                        <div style={{ marginTop: '-14px' }}>
                            <IconButton onClick={() => { setFullScreenLocal(!fullScreenLocal) }} >
                                {fullScreenLocal ? <CloseFullscreen /> : <Fullscreen />}
                            </IconButton>
                            <IconButton onClick={() => onClose(undefined)}><Close /></IconButton>
                        </div>
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Validate name='name-signup-validate' initialValidation={'noisy'} required={[true, t('FieldRequired')]}>
                    <TextField sx={{ margin: '12px', width: '526px' }} label={t('name')}
                        size='small'
                        name='userName'
                        variant='outlined'
                        value={templateLocal?.name}
                        error={!templateLocal?.name}
                        onChange={(e) => { setTemplateLocal(new CategoryTemplateDTO({ ...templateLocal, name: e.target.value })) }} />
                </Validate>
                <Button size='small' disabled={buttonDisabled} onClick={() => {
                    //setOpenNewCategoryDialog(true);
                    let novy = new CategoryTemplateDTO({ ...templateLocal, templateItems: [...templateLocal?.templateItems ?? [], new CategoryTemplateItemDTO({ name: '', id: 0 })] });
                    setTemplateLocal(novy);

                }} sx={{ background: theme.palette.primary.main, color: 'black', margin: 1, px: 1 }} startIcon={<Add />}>
                    {t('addFolder')}
                </Button>
                <List sx={{ width: '100%', maxHeight: '300px', bgcolor: 'background.paper', border: '1px solid lightgray', borderRadius: '10px', overflow: 'auto' }}>
                    {templateLocal?.templateItems && templateLocal.templateItems.filter(p => p!.id! >= 0).map((item, index) => (
                        <ListItem
                            key={item.id + '_' + index}
                            secondaryAction={
                                <IconButton
                                    onClick={() => handleDelete(item)}
                                >
                                    <Delete />
                                </IconButton>
                            }
                        >
                            <TextField
                                sx={{ width: '100%', mr: 1 }}
                                size="small"
                                value={item.name}
                                onChange={(e) => handleChange(item, e.target.value)}
                            />
                        </ListItem>
                    ))}
                </List>
                <DeleteDialog open={deleteItem !== undefined} onClose={() => { setDeleteItem(undefined) }} onDeleteAgree={(del) => {
                    if (del.id)
                        setTemplateLocal(new CategoryTemplateDTO({ ...templateLocal, templateItems: templateLocal?.templateItems?.map((item) => (item === del ? new CategoryTemplateItemDTO({ ...item, id: (-1) * item.id! }) : item)) ?? [] }));
                    else
                        setTemplateLocal(new CategoryTemplateDTO({ ...templateLocal, templateItems: templateLocal?.templateItems?.filter((item) => item !== del) ?? [] }));
                    setDeleteItem(undefined);
                }} data={deleteItem} />
            </DialogContent>
            <DialogActions>
                <Button sx={{ background: theme.palette.primary.main, color: 'black' }} onClick={() => { onClose(undefined) }}>{t('close')}</Button>
                <Button disabled={buttonDisabled} sx={{ background: theme.palette.primary.main, color: 'black' }} onClick={() => { onClose(templateLocal!) }}>{t('Confirm')}</Button>
            </DialogActions>
        </Dialog>
    )
}
